import setDragSourceElement from './set-drag-source-element';
import setDropTargetElement from './set-drop-target-element';
import setAdjacentPosition from './set-adjacent-position';

export default {
  setDragSourceElement,
  setDropTargetElement,
  setAdjacentPosition,
};
